import vuex from "src/vuex"
import router from "src/http/router";
import UserRole from "src/util/valueObjects/userRole";
import * as Cookies from "js-cookie";

export default (to, from, next) => {
  //é utilizado o cookie pois nao da tempo de recuperar do vuex, o cookie é mais rapido
  if(Cookies.getJSON("token").user.role.id !== UserRole.MANAGER.index){
    vuex.dispatch("redirectToMainMenu");
  }
  next();
};
